

konnyScript(function($){
	$('.crEventWrap .eprdImgSlide input[type=checkbox]').click(function(){
    	$('.crEventWrap .eprdImgSlide .swiper-slide input[type=checkbox]').prop("checked", false);
    	$(this).prop("checked", true);
    });
    
    $('.crEventWrap .eprdImgSlide .swiper-slide .recolImg').click(function(){
    	$('.crEventWrap .eprdImgSlide .swiper-slide input[type=checkbox]').prop("checked", false);
    });

    
    var swiper = new Swiper("#refresh_auto_swiper_slide1", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: true,
        speed:2000,
        autoplay:{
            delay:0,
            disableOnInteraction:false,
        },
        scrollbar: {
            el: '#refresh_auto_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '#refresh_auto_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#refresh_auto_swiper_slide1 .swiper-button-next',
            prevEl: '#refresh_auto_swiper_slide1 .swiper-button-prev',
        },
    });
    
    var swiper = new Swiper("#eclick_swiper_slide1", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: false,
        scrollbar: {
            el: '#eclick_swiper_slide1 .swiper-scrollbar',
        },
        pagination: {
            el: '#eclick_swiper_slide1 .swiper-pagination',
        },
        navigation: {
            nextEl: '#eclick_swiper_slide1 .swiper-button-next',
            prevEl: '#eclick_swiper_slide1 .swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 'auto',
                slidesPerGroup:1,
            },
        },
    });
    
    var swiper = new Swiper("#eclick_swiper_slide2", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: false,
        scrollbar: {
            el: '#eclick_swiper_slide2 .swiper-scrollbar',
        },
        pagination: {
            el: '#eclick_swiper_slide2 .swiper-pagination',
        },
        navigation: {
            nextEl: '#eclick_swiper_slide2 .swiper-button-next',
            prevEl: '#eclick_swiper_slide2 .swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 'auto',
                slidesPerGroup:1,
            },
        },
    });
    var swiper = new Swiper("#eclick_swiper_slide3", {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: false,
        scrollbar: {
            el: '#eclick_swiper_slide3 .swiper-scrollbar',
        },
        pagination: {
            el: '#eclick_swiper_slide3 .swiper-pagination',
        },
        navigation: {
            nextEl: '#eclick_swiper_slide3 .swiper-button-next',
            prevEl: '#eclick_swiper_slide3 .swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 'auto',
                slidesPerGroup:1,
            },
        },
    });
    
    $('[id^=\'eprd_swiper_slide\']').each(function(index){
        index = index+1;
        var slidePage1 = '#eprd_swiper_slide'+index+' .swiper-pagination';
        var slidePage2 = '#eprd_swiper_slide'+index+' .swiper-progress';
        var slideScr = '#eprd_swiper_slide'+index+' .swiper-scrollbar';
        var slideNext = '#eprd_swiper_slide'+index+' .swiper-button-next';
        var slidePrev = '#eprd_swiper_slide'+index+' .swiper-button-prev';
        var mallSlide = new Swiper(this,{
            slidesPerView: 'auto',
            slidesPerGroup:1,
            spaceBetween:10,
            centeredSlides:false,
            observer:true,
            observeParents:true,
            //loop: true,
            pagination:true,
            pagination:{
                el:slidePage2,
				type : 'progressbar'
            },
            scrollbar:{
                el:slideScr,
                hide:true,
            },
            navigation: {
                nextEl: slideNext,
                prevEl: slidePrev,
            },
            breakpoints: {
                768: {
                    slidesPerView: 'auto',
                    slidesPerGroup:1,
                },
            },
        });
    });
})